import axios from "axios"
import {progressModalInitView, progressViewChange, progressModalHandler} from "../../common/progress_modal";
import {errorMessageAdd, errorMessageClear} from "../common/error_message";

let successCount = 0;
let failCount = 0;

let uploadFile: File | undefined;

const allCheckGbpLocation = () => {
    const gbpLocalPostsIndex = document.getElementById('gbp_local_posts_index') as HTMLElement;
    const checkboxTh = document.getElementById('all_check_gbp_location_ids') as HTMLInputElement;
    checkboxTh.addEventListener('change', () => {
        const checkBoxTds = gbpLocalPostsIndex.querySelectorAll('td.check-box');
        checkBoxTds.forEach(checkBoxTd => {
            const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
            checkbox.checked = checkboxTh.checked;
        });
    });
}
const localPostsBulkCreateButtonActive = () => {
    const gbpLocalPostsIndex = document.getElementById('gbp_local_posts_index') as HTMLElement;
    fetchTopicTypes().forEach(topicType => {
        const localPostsBulkCreateButtonDiv = document.querySelector(`.gbp-${topicType}-local-posts-bulk-create-button`) as HTMLElement;
        const localPostsBulkCreateButton = localPostsBulkCreateButtonDiv.querySelector('[type="submit"]') as HTMLButtonElement;
        localPostsBulkCreateButton.disabled = true;
        const locationCheckboxTds = gbpLocalPostsIndex.querySelectorAll('td.check-box');
        locationCheckboxTds.forEach(locationCheckboxTd => {
            locationCheckboxTd.addEventListener('change', () => {
                localPostsEventBulkCreateButtonChange(localPostsBulkCreateButton, locationCheckboxTds)
            });
        });
        const locationCheckboxTh = document.getElementById('all_check_gbp_location_ids') as HTMLInputElement;
        locationCheckboxTh.addEventListener('change', () => {
            localPostsEventBulkCreateButtonChange(localPostsBulkCreateButton, locationCheckboxTds)
        });
    })
}
const localPostsEventBulkCreateButtonChange = (button: HTMLButtonElement, checkboxTds: NodeListOf<Element>) => {
    button.disabled = true;
    checkboxTds.forEach(checkboxTd => {
        const checkbox = checkboxTd.querySelector('input') as HTMLInputElement;
        if (checkbox.checked) {
            button.disabled = false;
            return
        }
    });
}



const initView = () => {
    const checkedTopicTypeRadio = document.querySelector<HTMLInputElement>('input[name="topic_type"]:checked');
    if (checkedTopicTypeRadio) {
        viewTopicTypeForm(checkedTopicTypeRadio)
    }
}
const switchTopicType = () => {
    const topicTypeRadios = document.querySelectorAll<HTMLInputElement>('input[name="topic_type"]');
    topicTypeRadios.forEach(topicTypeRadio => {
        topicTypeRadio.addEventListener('change', () => {
            viewTopicTypeForm(topicTypeRadio)
            formClear()
        });
    });
}
const viewTopicTypeForm = (selectedTopicType: HTMLInputElement) => {
    const topicTypeRadios = document.querySelectorAll<HTMLInputElement>('input[name="topic_type"]');
    topicTypeRadios.forEach(topicTypeRadio => {
        // radioボタンのvalueとフォームのクラス名が一致している前提
        const form = document.querySelector(`.${topicTypeRadio.value}`) as HTMLElement;
        form.style.display = selectedTopicType.value == topicTypeRadio.value ? 'block' : 'none';
    });
}

const buttonLinkHandler = () => {
    const topicTypes = fetchTopicTypes();
    topicTypes.forEach(topicType => {
        const button = document.getElementById(`${topicType}_button`) as HTMLSelectElement;
        const button_link = document.getElementById(`${topicType}_button_link`) as HTMLInputElement;
        button.addEventListener('change', () => {
            button_link.value = '';
            button.value == 'none' ? button_link.disabled = true : button_link.disabled = false;
        });
    });
}
const formClear = () => {
    const topicTypes = fetchTopicTypes();
    topicTypes.forEach(topicType => {
        const form = document.querySelector(`.${topicType}`) as HTMLElement;
        const inputs = form.querySelectorAll<HTMLInputElement>('input')
        inputs.forEach(input => {
            if (input.type != 'submit') {
                input.value = '';
            }
            if (input.type == 'file') {
                uploadFile = undefined
            }
        });
        const textareas = form.querySelectorAll<HTMLInputElement>('textarea')
        textareas.forEach(textarea => {
            textarea.value = '';
        });
    });

}
const fetchTopicTypes = () => {
    const topicTypeRadios = document.querySelectorAll<HTMLInputElement>('input[name="topic_type"]');
    let topicTypes = [] as string[];
    topicTypeRadios.forEach(topicTypeRadio => {
        topicTypes.push(topicTypeRadio.value)
    });
    return topicTypes;
}

const uploadInputFileField = () => {
    fetchTopicTypes().forEach(topicType => {
        const fileInput = document.getElementById(`${topicType}_upload_picture`) as HTMLInputElement;

        fileInput.addEventListener('change', (event) => {
            const target = event.target as HTMLInputElement;

            if (target.files && target.files.length > 0) {
                uploadFile = target.files[0];
            } else {
                uploadFile = undefined
            }
        })
    });
}

const fetchformDataLocalPostsBulkCreate = (file: File | undefined) => {
    const formData = new FormData();
    if (file) {
        formData.append('file', file);
    }
    const topic_type = document.querySelector<HTMLInputElement>('input[name="topic_type"]:checked');
    formData.append('topic_type', topic_type == null ? '' : topic_type.value);

    if (formData.get('topic_type') == 'standard') {
        formData.append('standard_description' , fetchInputItemElementById('standard_description'))
        formData.append('standard_button',  fetchInputItemElementById('standard_button'))
        formData.append('standard_button_link',  fetchInputItemElementById('standard_button_link'))

        validationStandard(formData)
    } else if (formData.get('topic_type') == 'event') {
        formData.append('event_title', fetchInputItemElementById('event_title'))
        formData.append('event_start_date', fetchInputItemElementById('event_start_date'))
        formData.append('event_start_time', fetchInputItemElementById('event_start_time'))
        formData.append('event_end_date', fetchInputItemElementById('event_end_date'))
        formData.append('event_end_time', fetchInputItemElementById('event_end_time'))
        formData.append('event_detail', fetchInputItemElementById('event_detail'))
        formData.append('event_button', fetchInputItemElementById('event_button'))
        formData.append('event_button_link', fetchInputItemElementById('event_button_link'))
        // validation
        validationEvent(formData)
    }
    return formData;
}

const fetchInputItemElementById = (elementId: string) => {
    const element = document.getElementById(elementId) as HTMLInputElement;
    return element == null ? '' : element.value;
}
const validationStandard = (formData: FormData) => {
    if (formData.get('standard_description') == '') {
        errorMessageAdd('説明が入力されていません')
    }
}

const validationEvent = (formData: FormData) => {
    if (formData.get('event_title') == '') {
        errorMessageAdd('イベントのタイトルが入力されていません')
    }
    if (formData.get('event_start_date') == '') {
        errorMessageAdd('開始日が入力されていません')
    }
    if (formData.get('event_end_date') == '') {
        errorMessageAdd('終了日が入力されていません')
    }
    if (formData.get('event_start_time') == '' && formData.get('event_end_time') != '') {
        errorMessageAdd('開始時間が入力されていません')
    }
    if (formData.get('event_start_time') != '' && formData.get('event_end_time') == '') {
        errorMessageAdd('終了時間が入力されていません')
    }
    if (formData.get('event_start_date') != '' && formData.get('event_end_date') != '') {
        const startUnixTime = new Date(`${formData.get('event_start_date')} ${formData.get('event_start_time')}`).getTime() / 1000;
        const endUnixTime = new Date(`${formData.get('event_end_date')} ${formData.get('event_end_time')}`).getTime() / 1000;
        const currentUnixTimestamp = Math.floor(new Date().getTime() / 1000);

        if (startUnixTime >= endUnixTime) {
            errorMessageAdd('終了日時が開始日時より前になっています')
        }
        if (currentUnixTimestamp >= endUnixTime) {
            errorMessageAdd('終了日時が過去の日時になっています')
        }
    }

}

const fetchBulkCreateLocationNames = () => {
    const gbpLocalPostsIndex = document.getElementById('gbp_local_posts_index') as HTMLElement;
    const checkBoxTds = gbpLocalPostsIndex.querySelectorAll('td.check-box');
    const locationNames = [] as string[];
    checkBoxTds.forEach(checkBoxTd => {
        const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
        if (checkbox.checked) {
            locationNames.push(checkbox.value)
        }
    });
    return locationNames;
}


const submitLocalPostsBulkCreate = () => {
    fetchTopicTypes().forEach(topicType => {
        const buttonDiv = document.querySelector(`.gbp-${topicType}-local-posts-bulk-create-button`) as HTMLElement;
        const button = buttonDiv.querySelector('[type="submit"]') as HTMLButtonElement;
        button.addEventListener('click', async () => {
            errorMessageClear()
            const locationNames: string[] = fetchBulkCreateLocationNames()
            console.log(locationNames)
            const locationGroupName = document.getElementById('location_group_name') as HTMLInputElement;
            const gbpLocalPostId = await createGbpLocalPosts()
            const errorMessageUl = document.querySelector('ul.gbp-error-message') as HTMLElement;
            if (errorMessageUl.childElementCount == 0) {
                [successCount, failCount] = progressModalInitView()
                locationNames.map((locationName) => {
                    let params = {} as any;
                    params['gbp_local_post_id'] = gbpLocalPostId
                    params['location_group_name'] = locationGroupName.value
                    params['location_name'] = locationName.split(',')[0]
                    params['location_title'] = locationName.split(',')[1]
                    submitLocalPostsBulkCreateRequest(params, locationNames.length)
                })
            }
        });
    })
}
const createGbpLocalPosts = async () => {
    const formData = fetchformDataLocalPostsBulkCreate(uploadFile);
    const errorMessageUl = document.querySelector('ul.gbp-error-message') as HTMLElement;
    if (errorMessageUl.childElementCount > 0) {
       return
    }
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    try {
        const response = await axios
            .post('/staff/api/gbp/gbp_local_posts', formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                    'X-CSRF-Token': token
                }
            })
        if (response.data['result']) {
            return response.data['gbp_local_post_id']
        } else {
            errorMessageAdd('最新情報の登録に失敗しました。')
            return
        }

    } catch (error) {
        errorMessageAdd('最新情報の登録に失敗しました。')
    }

}
const submitLocalPostsBulkCreateRequest = (params: any, baseCount: number) => {
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    const url = '/staff/api/gbp/local_posts/'
    const config = {headers: {'X-CSRF-Token': token}}
    // 連続でリクエストを送ると、paramsが上書きされてしまうため、paramsをコピーして送る
    axios.post(url, {...params}, config)
        .then(response => {
            const data = response.data;
            if (data['result']) {
                successCount += 1;
            } else {
                errorMessageAdd(data['message'])
                failCount += 1;
            }
            progressViewChange(successCount, failCount, baseCount)
        }).catch(error => {
        failCount += 1;
        progressViewChange(successCount, failCount, baseCount)
        errorMessageAdd('エラーが発生しました。')
    });
}

document.addEventListener('DOMContentLoaded', () => {

    const gbpLocalPostsIndex = document.getElementById('gbp_local_posts_index') as HTMLElement;
    if (gbpLocalPostsIndex == null) {
        return;
    }

    initView()
    switchTopicType()
    allCheckGbpLocation()
    localPostsBulkCreateButtonActive()
    buttonLinkHandler()
    submitLocalPostsBulkCreate()
    uploadInputFileField()
    progressModalHandler()

});
